<template>
  <div class="d-flex flex-column">
    <label class="text-body-2 text-center grey--text text--darken-2">{{
      label
    }}</label>
    <div
      class="
        align-self-md-center align-self-lg-center align-self-xl-center
        d-flex
        flex-row
        justify-space-between
        align-center
        mt-1
      "
    >
      <v-btn
        depressed
        small
        v-for="frecuencia in frecuencias"
        :key="frecuencia"
        :color="frecuenciaSeleccionada === frecuencia ? 'primary' : ''"
        class="mx-md-2 mx-lg-2 mx-xl-2"
        @click="seleccionarFrecuencia(frecuencia)"
      >
        {{ frecuencia }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    frecuencias: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      frecuenciaSeleccionada: '',
    }
  },
  methods: {
    seleccionarFrecuencia(frecuencia) {
      this.frecuenciaSeleccionada = frecuencia
      this.$emit('input', this.frecuenciaSeleccionada)
    },
  },
  created() {
    this.frecuenciaSeleccionada = this.value
  },
}
</script>

<style scoped>
.frecuencias {
  max-width: 400px;
}
</style>
